export default "__VITE_ASSET__BfPVhzQr__"